import { c as _c } from "react/compiler-runtime";
import { useEntityContext } from '@/entity/hooks/use-entity-context';
import type { WithEntityProps } from '../../../with-entity';
import BusinessVault from './components/business-vault';
import PersonVault from './components/person-vault';
type VaultProps = WithEntityProps;
const Vault = t0 => {
  const $ = _c(3);
  const {
    entity
  } = t0;
  const context = useEntityContext();
  let t1;
  if ($[0] !== context.kind || $[1] !== entity) {
    t1 = context.kind === "person" ? <PersonVault entity={entity} /> : <BusinessVault entity={entity} />;
    $[0] = context.kind;
    $[1] = entity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Vault;